export default {
    setRating(state, n) {
        state.rating.reviews = n
    },
    setDeferredPrompt(state, n) {
        state.deferredPrompt = n;
    },
    mode(state, n) {
        state.mode = n;
    },

    change(state) {
        state.changed = Math.random();
    },
    changeRegister(state) {
        state.changedRegister = Math.random();
    },
    page(state, n) {
        state.page = n;
    },
    language(state, n) {
        state.language = n;
    },
    wait(state, n) {
        state.wait = n;
    },
    alert(state, n) {
        state.messages = n;
    },
    regChange(state, n) {
        state.registers[n.name] = n.register;
    },
    enumChange(state, n) {
        state.enums[n.name] = n.register;
    },
    salaryChange(state, n) {
        state.salary.data = n;
    },
    formData200(state, n) {
        state.reports.form200.data = n;
    },
    user(state, n) {
        state.user = n
    },

    setRegister(state, n) {
        if (typeof n.list !== 'undefined') {
            state.registers[n.register].list = n.list;
            n.list.forEach(function(item){
                if (item.current) {
                    state.registers[n.register].current = item;
                }
            })
        }
        if (typeof n.default !== 'undefined') {
            state.registers[n.register].list = [];
            state.registers[n.register].current = n.default;
        }

    }
}